import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e38049d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "link-btn" }

import DbTableCsvHelper from '@/services/helpers/DbTableCsvHelper'
import useNotifier from '@/services/composables/Notifier'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportCsvModelAgnostic',
  props: {
    dataToDownload: {},
    columnsToRemove: {},
    fileName: {}
  },
  setup(__props: any) {

const props = __props

function exportFilteredDisplayable(dataToDownload: Record<string, any>[], fileName: string) {
  if (!dataToDownload.length) {
    useNotifier().warn({ msg: 'There is nothing in the table to export.' })
    return
  }

  let filteredData = dataToDownload

  if (props.columnsToRemove?.length) {
    filteredData = dataToDownload.map((item) => {
      const copy = { ...item }
      for (const key of props.columnsToRemove!) {
        delete copy[key]
      }
      return copy
    })
  }

  DbTableCsvHelper.generateCsvDownload(filteredData, fileName)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" ["),
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (exportFilteredDisplayable(props.dataToDownload, props.fileName)))
    }, "Export csv"),
    _createTextVNode("] ")
  ]))
}
}

})